(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jib1c0-bundle-variant-compact"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__jib1c0BundleSwatchDotInit) return;
    window.__jib1c0BundleSwatchDotInit = true;

    function paint(select) {
      var wrap = select.closest('[data-bundle-swatch-wrap]');
      if (!wrap) return;
      var dot = wrap.querySelector('[data-bundle-swatch-dot]');
      if (!dot) return;

      var option = select.options[select.selectedIndex];
      var swatch = option ? option.getAttribute('data-swatch') : null;

      dot.removeAttribute('style');
      if (!swatch) {
        /* Keep the attribute absent so the CSS collapse rule applies. */
        return;
      }
      if (swatch.indexOf('img ') === 0) {
        dot.style.setProperty('--swatch-image', 'url(' + swatch.slice(4) + ')');
      } else {
        dot.style.setProperty('--swatch-color', swatch);
      }
    }

    function paintAll(root) {
      var selects = (root || document).querySelectorAll('[data-bundle-swatch-wrap] [data-bundle-picker]');
      for (var i = 0; i < selects.length; i++) paint(selects[i]);
    }

    document.addEventListener('change', function (event) {
      var select = event.target;
      if (select && select.matches && select.matches('[data-bundle-picker]')) paint(select);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { paintAll(); });
    } else {
      paintAll();
    }

    /* Tiers re-render their rows when the shopper switches tier, so the fresh
       selects need painting too. */
    document.addEventListener('jib1c0:variant:changed', function () { paintAll(); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jib1c0-product-card-swatches"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__jib1c0CardSwatchesInit) return;
    window.__jib1c0CardSwatchesInit = true;

    function activate(swatch) {
      var card = swatch.closest('.jib1c0-product-card');
      if (!card) return;

      var newSrc = swatch.getAttribute('data-swatch-image');
      var primaryImg = card.querySelector('.jib1c0-product-card__primary img');
      if (primaryImg && newSrc) {
        primaryImg.setAttribute('src', newSrc);
        primaryImg.setAttribute('srcset', '');
      }

      var swatches = card.querySelectorAll('.jib1c0-card-swatches__swatch');
      for (var i = 0; i < swatches.length; i++) {
        swatches[i].classList.remove('jib1c0-card-swatches__swatch--active');
      }
      swatch.classList.add('jib1c0-card-swatches__swatch--active');
    }

    /* Hover for pointers, click for touch — mouseover never fires on a tap,
       so without the click handler the swatches were inert on mobile. */
    document.addEventListener('mouseover', function (event) {
      var swatch = event.target.closest('.jib1c0-card-swatches__swatch');
      if (swatch) activate(swatch);
    });

    document.addEventListener('click', function (event) {
      var swatch = event.target.closest('.jib1c0-card-swatches__swatch');
      if (!swatch) return;
      event.preventDefault();
      activate(swatch);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jib1c0-toast"] && !Shopify.designMode) return;
  try {
    class Jib1c0Toast extends HTMLElement {
    connectedCallback() {
      this.messageEl = this.querySelector('[data-ref="toast-message"]');
      this.closeBtn = this.querySelector('[data-ref="toast-close"]');
      this.timeout = null;

      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.hide());
      }

      /* Global API */
      window.Jib1c0Toast = {
        show: (msg, type, duration) => this.show(msg, type, duration),
        hide: () => this.hide()
      };
    }

    show(msg, type, duration) {
      if (!this.messageEl) return;
      var ms = duration || 4000;
      this.messageEl.textContent = msg;
      this.style.setProperty('--toast-duration', ms + 'ms');
      this.className = 'jib1c0-toast jib1c0-toast--visible';
      if (type) this.classList.add('jib1c0-toast--' + type);

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => this.hide(), ms);
    }

    hide() {
      this.classList.remove('jib1c0-toast--visible');
      clearTimeout(this.timeout);
    }
  }

  if (!customElements.get('jib1c0-toast')) {
    customElements.define('jib1c0-toast', Jib1c0Toast);
  }
  } catch(e) { console.error(e); }
})();

})();
